// The spaces of the workspace being shown, as the documents see them.
import {
  DOCUMENT_FEATURE,
  PAGE_WRITE,
} from "@trameria/cloud-api/workspace-documents-shared";
import type { SpaceView } from "@trameria/cloud-api/workspace-shared";
import { useCan, useWorkspace, useWorkspaceSpaces } from "../workspace";
import {
  newDocumentSpace,
  useDocsState,
  useLastDocumentSpace,
} from "./screen-state";

/** Spaces that hold documents (the feature on, not archived). */
export function useDocumentSpaces(): SpaceView[] {
  return useWorkspaceSpaces().filter((s) =>
    s.features.includes(DOCUMENT_FEATURE),
  );
}

/** Spaces one may make and write documents in (none without page.write). */
export function useWritableSpaces(): SpaceView[] {
  const spaces = useDocumentSpaces();
  return useCan()(PAGE_WRITE) ? spaces : [];
}

/** The space the next new document of this workspace goes to, and how to remember it. */
export function useNewDocumentSpace(): {
  space: SpaceView | null;
  spaces: SpaceView[];
  pick(spaceId: string): void;
  made(spaceId: string): void;
} {
  const { slug } = useWorkspace();
  const spaces = useWritableSpaces();
  const [state, setState] = useDocsState(slug);
  const [last, setLast] = useLastDocumentSpace(slug);
  return {
    space: newDocumentSpace(spaces, state, last),
    spaces,
    pick: (spaceId) => setState({ newSpaceId: spaceId }),
    made: (spaceId) => {
      setLast(spaceId);
      setState({ newSpaceId: null });
    },
  };
}
